import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ColDef, GridApi } from 'ag-grid-community';
import { logisticaModulo as diccionarios } from '../../logistica-diccionario';
import { CatalogosLogisticaService } from '../../service/catalogosLogistica.service';
import { LogisticaService } from '../../service/logistica.services';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { Chofer, muelleAsigando } from '../../../traslado-logist/model/model';
import { ClienteShort } from 'src/app/model/datos-maestros/cliente-short';

@Component({
  selector: 'app-editar-viaje',
  templateUrl: './editar-viaje.component.html',
  styleUrls: ['./editar-viaje.component.css']
})
export class EditarViajeComponent implements OnInit {
  public GLOBAL_TITULOS = diccionarios.titulos.global;
  public DAT_AG_GRID = diccionarios.agGrid;

  public titleModal: string = 'Editar Viaje';
  public loading: boolean = false;
  public mostrarEdicion: boolean = false;

  public frameworkComponents: any;
  public columnDefs: ColDef[] = [];
  public rowData: any[] = [];
  public rowSelection: any;
  public gridApi: GridApi;
  public gridColumnApi: any;
  public textoBuscar: string;

  public formulario: FormGroup;

  public usuarioActual: any;
  public viajeOriginal: any;
  public clienteElegido: ClienteShort | undefined;

  public listCentros: any[] = [];
  public listAgencias: any[] = [];
  public listChoferes: Chofer[] = [];
  public placas: any[] = [];
  public placasLoading = false;
  public listTipos: any[] = [];
  public listAdenes: muelleAsigando[] = [];

  constructor(
    private fb: FormBuilder,
    private utilServices: UtilsService,
    private logisticaAPI: LogisticaService,
    private catalogos: CatalogosLogisticaService,
    private dmaestrosAPI: DatosMaestrosService,
  ) {}

  ngOnInit(): void {
    this.usuarioActual = JSON.parse(localStorage.getItem('datosUsuarioLogin'));

    this.formulario = this.fb.group({
      idViaje: [{ value: '', disabled: true }],
      tipo: [''],
      centroOrigen: ['', Validators.required],
      bodegaCarga: ['', [Validators.required, Validators.maxLength(4)]],
      centroDestino: [''],
      proveedorId: ['', Validators.required],
      proveedorNombre: [{ value: '', disabled: true }],
      placa: ['', Validators.required],
      furgon: [''],
      choferNombreFiltro: [''],
      choferCedula: ['', Validators.required],
      choferNombre: [{ value: '', disabled: true }],
      choferTelefono: [{ value: '' }],
      cliente: [''],
      clienteNombre: [''],
      sellos: [''],
      andenId: [''],
    });

    this.formulario.get('proveedorId')?.valueChanges.subscribe(() => {
      this.formulario.get('proveedorNombre')?.reset();
      this.placas = [];
      this.formulario.get('placa')?.reset();
    });

    this.formulario.get('choferCedula')?.valueChanges.subscribe((cedula: any) => {
      if (!cedula) return;
      const chofer = this.listChoferes?.find(e => String(e.cedula) === String(cedula));
      if (chofer) {
        this.formulario.get('choferNombre')?.setValue(chofer.nombres);
        this.formulario.get('choferTelefono')?.setValue(chofer.fono);
      }
    });

    this.formulario.get('tipo')?.valueChanges.subscribe((tipoId: any) => {
      if (!tipoId) return;
      const tipoSeleccionado = this.listTipos?.find(t => String(t.idTipo) === String(tipoId));
      if (tipoSeleccionado && tipoSeleccionado.nombre === 'CLIENTE PTA') {
        this.formulario.get('centroDestino')?.setValue(null);
      }
    });

    this.formulario.get('centroOrigen')?.valueChanges.subscribe((idCentro: any) => {
      if (idCentro) this.getAlmacenByCentroUser(idCentro);
      this.listarAndenes();
    });

    this.formulario.get('bodegaCarga')?.valueChanges.subscribe(() => this.listarAndenes());

    this.cargarGridcomponent();
    this.cargarCentros();
    this.cargarTipos();
    this.listar();
  }

  cargarGridcomponent() {
    this.frameworkComponents = { buttonRenderer: LfsaBotonEditarGridComponent };
    this.columnDefs = this.catalogos.getColumnDefs();
    this.columnDefs.push({
      cellRenderer: 'buttonRenderer',
      initialPinned: 'left',
      width: 80,
      cellRendererParams: { onClick: this.editar.bind(this), label: 'Editar' }
    });
    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi?.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  listar() {
    this.rowData = [];
    this.logisticaAPI.getViajeByExcption(['FINALIZADO', 'ELIMINADO']).subscribe((res: any) => {
      if (res) this.rowData = res;
    }, (err) => {
      console.log(err.message);
    });
  }

  cargarCentros() {
    this.dmaestrosAPI.getAllCentroLogistico().subscribe((res: any[]) => {
      if (Array.isArray(res)) {
        this.listCentros = res.map((e: any) => {
          e.nombreCentro = `${e.idCentro} - ${e.nombreCentro}`;
          return e;
        });
      }
    }, (err) => {
      console.log(err.message);
    });
  }

  cargarTipos() {
    this.logisticaAPI.getTipos().subscribe((res: any) => {
      if (res) this.listTipos = res;
    }, (err) => {
      console.log(err.message);
    });
  }

  buscarChoferes() {
    const nombre = String(this.formulario.get('choferNombreFiltro')?.value ?? '').trim();
    if (!nombre) {
      this.listChoferes = [];
      return;
    }

    this.dmaestrosAPI.getChoferSearchNombres(nombre).subscribe((res: Chofer[]) => {
      this.listChoferes = Array.isArray(res) ? res : [];
    }, (err) => {
      console.log(err.message);
    });
  }

  getProveedor() {
    const id = String(this.formulario.get('proveedorId')?.value ?? '').trim();
    if (!id) return;
    this.dmaestrosAPI.getProveedorByID(+id).subscribe((res: any) => {
      if (res) {
        this.formulario.get('proveedorNombre')?.setValue(res?.nombre ?? '');
        this.getPlacas(id);
      } else {
        this.utilServices.alertatoastOK('No se encontró registro de proveedor');
      }
    }, (err) => {
      console.log(err.message);
    });
  }

  proveedorSeleccionado(proveedor: any) {
    this.formulario.get('proveedorId')?.setValue(proveedor?.idProveedor ?? null);
    this.formulario.get('proveedorNombre')?.setValue(proveedor?.nombre ?? '');
    if (proveedor?.idProveedor) {
      this.getPlacas(String(proveedor.idProveedor));
    }
  }

  clienteSeleccionado(cliente: ClienteShort) {
    this.clienteElegido = cliente;
    console.log('Cliente seleccionado:', this.clienteElegido);
    this.formulario.get('cliente')?.setValue(this.clienteElegido.idCliente);
    this.formulario.get('clienteNombre')?.setValue(this.clienteElegido.nombreCliente1);
  }

  getPlacas(idTransportista: string) {
    const id = String(idTransportista ?? '').trim();
    if (!id) return;
    this.placasLoading = true;
    this.placas = [];
    this.logisticaAPI.getPlacas(id).subscribe((res: any) => {
      this.placas = Array.isArray(res) ? res : [];
      this.placasLoading = false;
    }, (err) => {
      console.error(err.message);
      this.placasLoading = false;
    });
  }

  editar({ rowData }: any) {
    const idViaje = rowData?.idViaje;
    if (!idViaje) return;

    this.loading = true;
    this.logisticaAPI.getViaje(idViaje).subscribe((res: any) => {
      this.viajeOriginal = res;
      this.formulario.reset();
      this.listChoferes = [];
      this.placas = [];

      this.formulario.patchValue({
      idViaje: res?.idViaje ?? null,
      tipo: res?.tipo ?? null,
      centroOrigen: res?.centroOrigen ?? null,
      bodegaCarga: res?.bodegaCarga ?? null,
      centroDestino: res?.centroDestino ?? null,
      proveedorId: res?.proveedorId ?? null,
      proveedorNombre: res?.proveedorNombre ?? '',
      placa: res?.placa ?? null,
      furgon: res?.furgon ?? null,
      choferNombreFiltro: res?.choferNombre ?? '',
      choferCedula: res?.choferCedula ?? null,
      choferNombre: res?.choferNombre ?? '',
      choferTelefono: res?.choferTelefono ?? '',
      cliente: res?.cliente ?? '',
      clienteNombre: res?.clienteNombre ?? '',
      sellos:  res?.sellos ?? '',
      andenId: res?.andenId ?? '',
    });

      if (res?.proveedorId) {
        this.getPlacas(String(res.proveedorId));
      }

      if (res?.choferNombre) {
        this.buscarChoferes();
      }

      if (res?.centroOrigen) {
        this.getAlmacenByCentroUser(res.centroOrigen);
      }
      if (res?.andenId) {
        this.listarAndenes();
        this.formulario.get('andenId')?.setValue(res.andenId);
      }

      this.mostrarEdicion = true;
      this.loading = false;
    }, (err) => {
      console.log(err.message);
      this.loading = false;
    });
  }

  acciones(event: any) {
    if (event === 'guardar') {
      this.guardarCambios();
      return;
    }
    this.mostrarEdicion = false;
  }

  guardarCambios() {
    if (!this.viajeOriginal) return;
    if (this.formulario.invalid) return;

    const raw = this.formulario.getRawValue();
    const payload = {
      ...this.viajeOriginal,
      tipo: raw.tipo,
      centroOrigen: raw.centroOrigen,
      bodegaCarga: raw.bodegaCarga,
      centroDestino: raw.centroDestino,
      choferCedula: raw.choferCedula,
      choferNombre: raw.choferNombre,
      choferTelefono: raw.choferTelefono,
      placa: raw.placa,
      furgon: raw.furgon,
      proveedorId: raw.proveedorId,
      proveedorNombre: raw.proveedorNombre,
      cliente: raw.cliente,
      clienteNombre: raw.clienteNombre,
      modificadoPor: this.usuarioActual?.login2 ?? this.usuarioActual?.login ?? '',
      sellos : raw.sellos,
      andenId: raw.andenId,
    };

    this.loading = true;
    this.utilServices.confirmarSincronoPromesa({
      title: diccionarios.mensajes.actualizar,
      text: 'Editar Viaje',
      action: this.GLOBAL_TITULOS.tituloActualizar,
      funcion: this.logisticaAPI.updateViaje(payload),
    }).then(() => {
      this.listar();
      this.mostrarEdicion = false;
      this.loading = false;
    }).catch(() => {
      this.loading = false;
    });
  }

  openModal() {
    document.getElementById('abrirModalEditarViaje')?.click();
  }

  closeModal() {
    document.getElementById('cerrarModalEditarViaje')?.click();
  }

  getAlmacenByCentroUser(eventOrValue: any) {
    console.log('getAlmacenByCentroUser ->', eventOrValue);

    let idCentro = eventOrValue?.target ? eventOrValue.target.value : eventOrValue;

    this.listAgencias = [];
    this.logisticaAPI.getConfigTrasladosAlmacenOrigen(this.usuarioActual.id, idCentro).subscribe((res) => {
      if (Array.isArray(res) && res.length > 0) {
        console.log('fill config almacen by user');
        this.listAgencias = res.map(e => { e.dscaAlmacen = e.idAlmacen + ' - ' + e.dscaAlmacen; return e; });
      } else {
        console.log('fill config almacen all');
        this.getAlmacen();
      }
    }, (err) => {
      console.log('fill config almacen all');
      this.getAlmacen();
      console.log(err.message);
    });
  }

  getAlmacen() {
    console.log('-> getAlmacen');
    const idCentro = this.formulario.get('centroOrigen')?.value;
    if (!idCentro) return;

    this.dmaestrosAPI.getAllAlmacenByCentro(idCentro).subscribe((res) => {
      if (res) {
        this.listAgencias = res.map(e => { e.dscaAlmacen = e.idAlmacen + ' - ' + e.dscaAlmacen; return e; });
      }
    }, (err) => {
      console.log(err.message);
    });
  }

  listarAndenes() {
    const centro = this.formulario.get('centroOrigen')?.value;
    const almacen = this.formulario.get('bodegaCarga')?.value;

    if (!centro || !almacen) {
      this.listAdenes = [];
      return;
    }

    this.logisticaAPI.getMuelles(centro, almacen).subscribe((res: muelleAsigando[]) => {
      if (res) this.listAdenes = res;
    }, (err) => {
      console.log(err.message);
    });
  }
}

